import { BaseDto } from '../base.dto';
import { CustomerDto } from '../customer.dto';
import { PaymentDto } from '../payment.dto';
import { GiftCardAddressDto } from './giftCardAddress.dto';
import { GiftCardReasonDto } from './giftCardReason.dto';
import { GiftCardSalesChannelDto } from '../giftCardSalesChannel.dto';
import { GiftCardTypeDto } from './giftCardType.dto';

export class GiftCardDto extends BaseDto {
  customerName?: string;
  customerEmail?: string;
  number: string;
  amount: number;
  note?: string;
  fromName?: string;
  fromEmail?: string;
  message?: string;
  deliveryDate?: Date;
  startDate?: Date;
  endDate?: Date;
  balance: number;
  giftCardType: GiftCardTypeDto;
  payments: PaymentDto[];
  address: GiftCardAddressDto[];
  active?: boolean;
  cvvCode?: number;
  deliveryDateAsInt?: number;
  isLoyaLapCard?: boolean;
  sendCopyToPurchaser: boolean;
  giftCardReason: GiftCardReasonDto;
  customer?: CustomerDto;
  isRefunded?: boolean;
  googleWalletJwtLink?: string;
  appleWalletS3Link?: string;
  enableSendEmails?: boolean;
  giftCardLink?: string;
  giftCardSalesChannel?: GiftCardSalesChannelDto;
  isStaffCard?: boolean;
  isPhysical?: boolean;
}
